/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Attributes_Not_EditableInputs */

const en_error_attributes_not_editable = /** @type {(inputs: Error_Attributes_Not_EditableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow is reviewing these attributes: you can change them again if they come back to you.`)
};

/**
* | output |
* | --- |
* | "Tomorrow is reviewing these attributes: you can change them again if they come back to you." |
*
* @param {Error_Attributes_Not_EditableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_attributes_not_editable = /** @type {((inputs?: Error_Attributes_Not_EditableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Attributes_Not_EditableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_attributes_not_editable(inputs)
});